<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/mHw9ug/tc-custom/9783988264435.jpg?1704453728404" alt="This image is the cover for the book New Lands Within The Arctic Circle, Classics To Go"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">New Lands Within The Arctic Circle, Classics To Go
      </h1>
      <p class="bookDescription body article font2">
        <p>New Lands Within The Arctic Circle is a non-fiction book written by Julius Payer, an Austrian explorer who was a member of the Austro-Hungarian North Pole Expedition of 1872-1874. The book is a detailed account of the expedition's journey to the Arctic region, including their observations of the landscape, wildlife, and the daily life of the native people they encountered. Payer describes the harsh conditions of the Arctic climate and the difficulties the expedition faced in their attempts to navigate the treacherous terrain. He also documents the expedition's interactions with the Inuit people and their cultural practices, as well as their discovery of new lands and geographical features. The book contains numerous illustrations and maps, providing a visual record of the expedition's findings. Overall, "New Lands Within The Arctic Circle" provides a fascinating glimpse into the world of Arctic exploration in the late 19th century.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Julius Payer
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      OTB ebook
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1bdfec98